import format from 'date-fns/format';

// 参考
// https://gitlab.dev-internal.crmstyle.com/synergy/typhoon/piclib/picture-libraries/-/blob/v0.1.76/piclib-submission-ui/src/assets/javascripts/piclib-submission.coffee#L14
export const formatForPuttingS3 = (date: Date): string => {
  return format(date, 'E, d LLL yyyy HH:mm:ss xx');
};
